// extracted by mini-css-extract-plugin
export var container = "statsArea-module--container--3_Qva";